import { render, staticRenderFns } from "./TaskAssignedUser.vue?vue&type=template&id=fc20e488&"
import script from "./TaskAssignedUser.vue?vue&type=script&lang=js&"
export * from "./TaskAssignedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports